
<template>
  <div>
    <projects-doing class="my-2"></projects-doing>
    <projects-done class="my-2"></projects-done>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ProjectsDoing from './list/ProjectsDoing.vue'
import ProjectsDone from './list/ProjectsDone.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ProjectList',
  //mixins: [ validations ],
  components: {
    ProjectsDoing,
    ProjectsDone
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>